/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdetails1Inputs */

const en_eventdetails1 = /** @type {(inputs: Eventdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Details`)
};

const de_eventdetails1 = /** @type {(inputs: Eventdetails1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventdetails`)
};

/**
* | output |
* | --- |
* | "Event Details" |
*
* @param {Eventdetails1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdetails1 = /** @type {((inputs?: Eventdetails1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdetails1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdetails1(inputs)
	return de_eventdetails1(inputs)
});
export { eventdetails1 as "eventDetails" }